import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { settingsStoreToken } from '../../../../../../cross-team-shared/state/setting-state';
import { toggleGroundIcon } from '../../../../../shared/icons/toolbars/toggle-ground-icon';
import { toggleRouteIcon } from '../../../../../shared/icons/toolbars/toggle-route-icon';
import { topViewIcon } from '../../../../../shared/icons/toolbars/top-view-icon';
import { RootKeyboardShortcutService } from '../../../../../shared/keyboard-shortcuts/root-keyboard-shortcut.service';
import { SettingsService } from '../settings.service';

@Component({
  selector: 'h3-settings',
  templateUrl: './settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SettingsComponent {
  private readonly settingsService = inject(SettingsService);
  private readonly keyboardShortcutService = inject(
    RootKeyboardShortcutService,
  );

  settingsStore = inject(settingsStoreToken);
  toggleOrthographicCameraTooltip =
    'Top view' +
    this.keyboardShortcutService.tooltipSuffix('toggleOrthographicCamera');
  toggleRouteIcon = toggleRouteIcon;
  toggleGroundIcon = toggleGroundIcon;
  topViewIcon = topViewIcon;

  toggleOrthographicCamera() {
    this.settingsService.toggleOrthographicCamera({ source: 'button' });
  }

  toggleHideGround() {
    this.settingsService.toggleHideGround();
  }

  toggleShowRoute() {
    this.settingsService.toggleShowRoute();
  }
}
